import i18n from "../../../i18n";
import DateService from "../../../services/dateService";


export const ICO_PREBO_TABLE_FIELDS_CONFIG = [

  {
    name: "lender",
    getValueCallback: (rowData) => rowData.lender,
    label: i18n.t("table.icos_table.lender"),
  },
  {
    name: "borrower",
    getValueCallback: (rowData) => rowData.borrower,
    label: i18n.t("table.icos_table.borrower"),
  },
  {
    name: "icoprebo_date_activation",
    getValueCallback: (rowData) =>
      DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.icoprebo_date_activation),
    label: i18n.t("table.icos_table.icoprebo_date_activation")
  },
  {
    name: "icoprebo_value_original",
    getValueCallback: (rowData) => rowData.icoprebo_value_original,
    label: i18n.t("table.icos_table.icoprebo_value_original"),
  },
  {
    name: "condition_prebo_interests",
    getValueCallback: (rowData) => rowData.icoprebo_interests_xlsx,
    label: i18n.t("table.icos_table.condition_prebo_interests"),
  },
  {
    name: "currency",
    getValueCallback: (rowData) => rowData.currency,
    label: i18n.t("table.icos_table.currency"),
  },
  {
    name: "icoprebo_note_finance",
    getValueCallback: (rowData) => rowData.icoprebo_note_finance,
    label: i18n.t("table.icos_table.note_finance"),
  },
];


export const ICO_PARENT_TABLE_FIELDS_CONFIG = [
  {
    name: "ico_nr",
    getValueCallback: (rowData) => rowData.ico_nr,
    label: i18n.t("table.icos_table.agreement_number"),
  },  
  {
    name: "lender",
    getValueCallback: (rowData) => rowData.lender,
    label: i18n.t("table.icos_table.lender"),
  },
  {
    name: "borrower",
    getValueCallback: (rowData) => rowData.borrower,
    label: i18n.t("table.icos_table.borrower"),
  },
  {
    name: "ico_date_activation",
    getValueCallback: (rowData) =>
      DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.ico_date_activation),
    label: i18n.t("table.icos_table.date_activation")
  },
  {
    name: "ico_date_repayment",
    getValueCallback: (rowData) =>
      DateService.convertDatetimeFromBackendToFormatYYYYMMDD(rowData.ico_date_repayment),
    label: i18n.t("table.icos_table.date_repayment"),
  },
  {
    name: "condition_value",
    getValueCallback: (rowData) => rowData.condition_value,
    label: i18n.t("table.icos_table.condition_value"),
  },
  {
    name: "condition_margin",
    getValueCallback: (rowData) => rowData.condition_margin,
    label: i18n.t("table.icos_table.margin"),
  },
  {
    name: "interest",
    getValueCallback: (rowData) => rowData.interest,
    label: i18n.t("table.icos_table.interest"),
  },
  {
    name: "currency",
    getValueCallback: (rowData) => rowData.currency,
    label: i18n.t("table.icos_table.currency"),
  },
];

